module.exports = __webpack_public_path__ + "img/share.15eb060e.svg";